import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiUser, FiLock, FiLogIn } from 'react-icons/fi';

const API = process.env.REACT_APP_API_BASE_URL || '';

const AdminLogin = ({ onLogin }) => {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!login || !senha) { setError('Preencha todos os campos.'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ login, senha })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || 'Credenciais inválidas.'); return; }
      localStorage.setItem('admin_token', data.token);
      onLogin(data.admin, data.token);
    } catch {
      setError('Erro de conexão.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white">AyTech <span className="text-blue-400">Admin</span></h1>
          <p className="text-gray-400 text-sm mt-1">Painel de gerenciamento</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-gray-800/60 backdrop-blur-md rounded-2xl border border-gray-700 p-8 space-y-5">
          <div className="relative">
            <FiUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" />
            <input
              id="admin-login"
              type="text"
              value={login}
              onChange={e => { setLogin(e.target.value); setError(null); }}
              placeholder="Login"
              autoComplete="username"
              className="w-full pl-11 pr-4 py-3 bg-gray-900/50 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 transition-colors"
            />
          </div>
          <div className="relative">
            <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" />
            <input
              id="admin-senha"
              type="password"
              value={senha}
              onChange={e => { setSenha(e.target.value); setError(null); }}
              placeholder="Senha"
              autoComplete="current-password"
              className="w-full pl-11 pr-4 py-3 bg-gray-900/50 border border-gray-600 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-blue-500 transition-colors"
            />
          </div>

          <AnimatePresence>
            {error && (
              <motion.p
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                className="text-red-400 text-sm text-center"
              >
                {error}
              </motion.p>
            )}
          </AnimatePresence>

          <motion.button
            type="submit"
            disabled={loading}
            whileHover={{ scale: loading ? 1 : 1.02 }}
            whileTap={{ scale: loading ? 1 : 0.98 }}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 text-white font-semibold rounded-xl flex items-center justify-center gap-2 transition-colors"
          >
            {loading ? (
              <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <><FiLogIn className="w-5 h-5" /> Entrar</>
            )}
          </motion.button>
        </form>

        <a href="/"
          className="mt-4 w-full py-2.5 border border-gray-600 text-gray-400 hover:text-white hover:border-gray-400 font-medium rounded-xl flex items-center justify-center gap-2 transition-colors text-sm"
        >
          ← Voltar ao site
        </a>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
